import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import './Slider.css'; // Ensure your CSS file is imported

const Slider = ({ initialStatus, onChangeStatus }) => {
  const [selectedValue, setSelectedValue] = useState('Not Seen');

  useEffect(() => {
    if (initialStatus) {
      setSelectedValue(initialStatus);
    }
  }, [initialStatus]);

  const handleSelect = (newValue) => {
    setSelectedValue(newValue);
    onChangeStatus(newValue);
  };
  const getButtonClass = () => {
    switch (selectedValue) {
      case 'Not Seen':
        return 'btn-light'; // Gray
      case 'Seen':
        return 'btn-info'; 
      case 'Not Shortlisted':
        return 'btn-danger'; // Red
      case 'Shortlisted':
        return 'btn-success'; // Green
      default:
        return 'btn-secondary';
    }
  };
  return (
    <div className="btn-group dropup">
      <Dropdown> {/* <-- This is key */}
        <Dropdown.Toggle as="div" className="toggle-hidden">
          <button
            className={`btn ${getButtonClass()} text-white custom-btn btn-sm dropdown-toggle`}
            type="button"
          >
            {selectedValue}
          </button>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-button-drop-up">
          <Dropdown.Item onClick={() => handleSelect("Not Seen")}>
            <span className="ul-task-manager__dot bg-light me-2"></span>
            Not Seen
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSelect("Seen")}>
            <span className="ul-task-manager__dot bg-info me-2"></span>
            Seen
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSelect("Not Shortlisted")}>
            <span className="ul-task-manager__dot bg-danger me-2"></span>
            Not Shortlisted
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSelect("Shortlisted")}>
            <span className="ul-task-manager__dot bg-success me-2"></span>
            Shortlisted
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>

  );
};

export default Slider;